import { useContext } from 'react';
import { SearchResultContext, SearchResultMutatorContext } from './searchContext';

export const useSearchResultMutator = () => useContext(SearchResultMutatorContext);
export const useSearchResultSelector = () => useContext(SearchResultContext);
